import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';

export const cartActionsStyles = StyleSheet.create({
  removeText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$bbqBrown,
  },
});
